import { render, staticRenderFns } from "./InputCep.vue?vue&type=template&id=2b961c3f&scoped=true&"
import script from "./InputCep.vue?vue&type=script&lang=js&"
export * from "./InputCep.vue?vue&type=script&lang=js&"
import style0 from "./InputCep.vue?vue&type=style&index=0&id=2b961c3f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b961c3f",
  null
  
)

export default component.exports